import { PostData } from '../types';

export const manualStoryA = (data: PostData) =>
  !data.hasDirectPublishProfile && data.publishingMethod !== 'MANUAL' && data.feedType === 'story';
